import { Slide, useScrollTrigger } from "@mui/material"
import { ReactElement } from "react"

interface HideOnScrollProps {
    children: ReactElement
}

/** Function which hides children when scrolling down */
const HideOnScroll = ({ children }: HideOnScrollProps): ReactElement => {
    const trigger = useScrollTrigger({
        threshold: 10, // adjust this value as needed
    })

    return (
        <Slide appear direction="up" in={!trigger}>
            {children}
        </Slide>
    )
}

export default HideOnScroll
